module.exports = __webpack_public_path__ + "static/media/pdf.96221021.png";